
import React from 'react';
import RichTextEditor from './RichTextEditor';
import { saveBusinessSetting } from '@/utils/businessService';

interface HowItWorksEditorProps {
  initialContent: string;
  onSaved?: () => void;
}

const HowItWorksEditor: React.FC<HowItWorksEditorProps> = ({ initialContent, onSaved }) => {
  const handleSave = async (content: string) => {
    await saveBusinessSetting('howItWorks', content);
  };

  return (
    <RichTextEditor
      title="How It Works"
      initialContent={initialContent}
      onSave={handleSave}
      onSaved={onSaved}
    />
  );
};

export default HowItWorksEditor;
